var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isNavbarHidden)?_c('Navbar',{attrs:{"auto-hide":_vm.isBibleStudyPage}}):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }